import React from 'react';
import { Button } from './ui/button';
import { Sparkles, Heart, BookOpen } from 'lucide-react';

const Difference = () => {
  const differences = [
    {
      icon: Sparkles,
      title: 'Tailored Solutions',
      description: 'One-size-fits-all doesn\'t work. We personalize every step of your financial journey to match your unique circumstances and goals.'
    },
    {
      icon: Heart,
      title: 'Community First',
      description: 'We focus on serving and uplifting underserved populations, bringing financial empowerment to communities that need it most.'
    },
    {
      icon: BookOpen,
      title: 'Education Forward',
      description: 'Real results start with real knowledge. We prioritize teaching you the fundamentals so you can make informed financial decisions.'
    }
  ];

  return (
    <section className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-serif text-[#0A2540] font-bold text-center mb-16">
          The Brooks & Associates Difference
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {differences.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="bg-white p-3 rounded-lg shadow-md">
                    <Icon className="h-8 w-8 text-[#0B8FD8]" />
                  </div>
                </div>
                <h3 className="text-xl md:text-2xl font-serif text-[#0A2540] font-bold">
                  {item.title}
                </h3>
                <p className="text-base text-[#2C3E50] leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Button 
            className="bg-[#0B8FD8] hover:bg-[#0973B0] text-white px-8 py-3 text-base rounded-md transition-all duration-300 shadow-lg hover:shadow-xl"
            onClick={() => window.open('https://go.sbrooksassociatesllc.com/bookwithshannon', '_blank')}
          >
            Get Started
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Difference;
